import { useFormikContext } from "formik"
import React from "react"
import { findField } from "@app/utils/form"
import { useRouteLoaderData } from "react-router-dom"
import { compareMeasureLabels } from "@app/utils/helper"

function setSelectOption (selectField, options) {
	if (selectField) {
		if (!selectField.defaultOptions) {
			selectField.defaultOptions = [...(selectField.options || [])]
		}
		const additionalOptions = options
			.map((value) => value.trim())
			.sort(compareMeasureLabels)
			.map(value => ({
				value: value,
				label: value,
			})) || []
		selectField.options = [
			...additionalOptions,
		]
	}
}

export const useEquipmentObserver = (currentFieldsets) => {
	const { values } = useFormikContext()
	const { measuresCatalogue, jobs } = useRouteLoaderData("root") || {}
	const jobId = values["taetigkeit_beschreibung_ueberlassungals__ID"]

	// set equipment options in dependency on jobId
	let res = React.useMemo(() => {
		const equipmentFormGroup = findField(currentFieldsets, "taetigkeitsort_arbeitsmittel_arbeitsmittel")
		if (equipmentFormGroup?.formGroup) {
			const equipmentNameField = findField([equipmentFormGroup.formGroup], "taetigkeitsort_arbeitsmittel_arbeitsmittel_name")
			let options = measuresCatalogue.Werkzeug
			// Job-spezifische Werkzeuge werden auf Kundenwunsch doch nicht verwendet
			/*if (jobId) {
				const job = jobs.find(({ Berufschluessel }) => Berufschluessel === jobId)
				if (job?.Werkzeug) {
					options = Object.values(job?.Werkzeug)
				}
			}*/
			setSelectOption(equipmentNameField, options)
		}

		return {
			fieldsets: currentFieldsets,
		}
	}, [jobId, currentFieldsets])

	return res
}
